<template>
  <div class="radiobox">
    <label :class="value===opt?'selected':''" :key="o" v-for="(opt, o) in options" :for="opt" :style="[fontSize?{fontSize}:{}]">
      <input type="radio" :name="opt" :id="opt" v-model="value" :value="opt">{{opt}}</label>
  </div>
</template>

<script>
export default {
  props: ['options', 'defaultValue', 'fontSize'],
  data () {
    return {
      value: null
    }
  },
  watch: {
    defaultValue () {
      this.value = this.defaultValue
    },
    value () {
      if (this.value !== this.defaultValue) {
        this.$emit('input', this.value)
      }
    }
  },
  mounted () {
    this.value = this.defaultValue
  }
}
</script>

<style lang="scss" scoped>
.radiobox {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 25px;
  flex-wrap: wrap;
}
label {
  display: flex;
  align-items: center;
  gap: .5em;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #6D6D6D;
  &::before {
    content: '';
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 12px;
    border: 2px solid var(--color-pri);
  }
  &.selected::before {
    background-color: var(--color-checked);
    background-image: url(/svg/status/circle.svg);
    background-repeat: no-repeat;
    background-position: center;
  }
}
input[type=radio] {
  display: none;
}
</style>
